import { useState } from "react";
import { getPinList } from "services/pinata";

export const useGetPinList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const [error, setError] = useState(false);

  const execute = async (JWT) => {
    try {
      setIsLoading(true);
      const res = await getPinList(JWT);
      const { data } = res;
      setData(data);
      return data;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };
  return { isLoading, data, error, execute };
};
